import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { CHUNGCHINGOAINGU_API } from '@app/utils/apiUrl';
import { Post } from '@app/utils/httpProvider';
import { getUser } from '@app/utils/oidc';
import { messageToast, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import ChungChiNgoaiNguForm from './ChungChiNgoaiNguForm';

const ChungChiNgoaiNguAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) => Post(CHUNGCHINGOAINGU_API.ADD_ITEM, null, value, false));

    const handleCreate = async (values) => {
        setIsLoading(true);
        try {
            const user = await getUser();
            const accountId = user?.profile?.sub;
            
            if (!accountId) {
                toast.error('Không lấy được thông tin tài khoản');
                setIsLoading(false);
                return;
            }

            const model = {
                accountId: accountId,
                soChungChi: values.soChungChi,
                tenChungChi: values.tenChungChi,
                loaiNgoaiNgu: values.loaiNgoaiNgu || null,
                trinhDo: values.trinhDo,
                diemSo: values.diemSo ? parseFloat(values.diemSo) : null,
                ngayCap: values.ngayCap ? new Date(values.ngayCap).toISOString() : null,
                ngayHetHan: values.ngayHetHan ? new Date(values.ngayHetHan).toISOString() : null,
                thoiHan: values.thoiHan || null,
                donViCap: values.donViCap || null,
                quocGiaCap: values.quocGiaCap,
                fileMinhChungId: values.fileMinhChungId || null,
                ghiChu: values.ghiChu || null
            };

            addFunc.mutate(model, {
                onSuccess: (res) => {
                    if (res.status !== status200) {
                        toast.error(messageToast.messageToastCreateError);
                    } else {
                        setIsLoading(false);
                        toast.success(messageToast.messageToastCreateSuccess);
                        history.push(URI_INTERNAL.CHUNGCHINGOAINGU_PATH);
                    }
                },
                onError: (err) => {
                    setIsLoading(false);
                    toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại !');
                }
            });
        } catch (error) {
            setIsLoading(false);
            console.error('Lỗi tạo Chứng chỉ ngoại ngữ:', error);
            toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
        }
    };

    return (
        <ChungChiNgoaiNguForm
            title="Thêm mới Chứng chỉ ngoại ngữ"
            submitText="Lưu thông tin"
            initialValues={{
                soChungChi: '',
                tenChungChi: '',
                loaiNgoaiNgu: '',
                trinhDo: '',
                diemSo: '',
                ngayCap: '',
                ngayHetHan: '',
                thoiHan: '',
                donViCap: '',
                quocGiaCap: '',
                fileMinhChungId: '',
                ghiChu: ''
            }}
            onSubmit={handleCreate}
            onCancel={() => history.push(URI_INTERNAL.CHUNGCHINGOAINGU_PATH)}
            isSubmitting={isLoading}
        />
    );
};

export default ChungChiNgoaiNguAdd;
